import { useTranslation } from "react-i18next";
import { Drawer } from "melco-ui";
import { AddMachineList } from "./AddMachineList";

type AddMachineDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
};

export const AddMachineDrawer: React.FC<AddMachineDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={t("reporting.machines.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      <AddMachineList />
    </Drawer>
  );
};
